export default __webpack_public_path__ + "1ee5224788c71ffaaa5cc559833cf82c.ico";